import React from 'react';
import {
  Select,
  MenuItem,
  SelectChangeEvent
} from '@mui/material';
import {
  Bar,
  Line,
  Pie,
  Doughnut,
} from 'react-chartjs-2';
import type { ChartData, ChartOptions } from 'chart.js';

// Define supported chart types
type ChartType = 'bar' | 'line' | 'pie' | 'doughnut';

// Props interface
interface TrendCardProps {
  title: string;
  chartType: ChartType;
  chartData: ChartData<any>;
  chartOptions?: ChartOptions<any>;
  timeFilters?: boolean;
  filters: string;
  setFilters: (filters: string) => void;
}

const TrendCard: React.FC<TrendCardProps> = ({
  title,
  chartType,
  chartData,
  chartOptions,
  timeFilters = false,
  filters,
  setFilters,
}) => {

  const handleChange = (event: SelectChangeEvent) => {
    setFilters(event.target.value);
  };

  // Dynamically render the chart based on type
  const renderChart = () => {
    switch (chartType) {
      case 'bar':
        return <Bar data={chartData} options={chartOptions} />;
      case 'line':
        return <Line data={chartData} options={chartOptions} />;
      case 'pie':
        return <Pie data={chartData} options={chartOptions} />;
      case 'doughnut':
        return <Doughnut data={chartData} options={chartOptions} />;
      default:
        return null;
    }
  };

  return (
    <div className="cards">
      <div className="cards_header">
        <div className="left_s">
          <h2>{title}</h2>
        </div>
        <div className="right_s">
          {timeFilters && (
            <Select
              size="small"
              value={filters}
              onChange={handleChange}
              sx={{ fontSize: '0.8rem', minWidth: 100 }}
            >
              <MenuItem value="weekly">Weekly</MenuItem>
              <MenuItem value="monthly">Monthly</MenuItem>
              <MenuItem value="yearly">Yearly</MenuItem>
              <MenuItem value="all">All Time</MenuItem>
            </Select>
          )}
        </div>
      </div>
      {/* Chart Container */}
      {renderChart()}
    </div>
  );
};

export default TrendCard;
